import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CentrosCostoDto } from 'src/app/models/centros-costo.dto';

@Component({
  selector: 'app-modal-centros-costo',
  templateUrl: './modal-centros-costo.component.html',
  styleUrls: ['./modal-centros-costo.component.scss']
})
export class ModalCentrosCostoComponent implements OnInit {

  centrosCosto: CentrosCostoDto[] = [];
  centrosCostoFiltrados: CentrosCostoDto[] = [];

  searchTerm: string = '';

  constructor(
    public dialogRef: MatDialogRef<ModalCentrosCostoComponent>,
    @Inject(MAT_DIALOG_DATA) public data: CentrosCostoDto[]
  ) { }

  ngOnInit(): void {
    this.centrosCosto = this.data || [];
    this.centrosCostoFiltrados = [...this.centrosCosto];
  }

  filtrar(): void {
    const termino = this.searchTerm.trim().toLowerCase();
    if (termino.length > 0) {
      this.centrosCostoFiltrados = this.centrosCosto.filter(c =>
        c.descrip_cenco?.toLowerCase().includes(termino) ||
        c.codi_cenco?.toLowerCase() === termino
      );
    } else {
      this.centrosCostoFiltrados = [...this.centrosCosto];
    }
  }

  onSearch(): void {
    if (this.searchTerm && this.searchTerm.length < 3) {
      this.centrosCostoFiltrados = [];
      return;
    }
    this.filtrar();
  }

  seleccionar(cenco: CentrosCostoDto): void {
    this.dialogRef.close({ response: cenco });
  }
}
